import { render, staticRenderFns } from "./MarkdownEditor.vue?vue&type=template&id=60143933&scoped=true&"
import script from "./MarkdownEditor.vue?vue&type=script&lang=js&"
export * from "./MarkdownEditor.vue?vue&type=script&lang=js&"
import style0 from "./MarkdownEditor.vue?vue&type=style&index=0&id=60143933&prod&lang=scss&"
import style1 from "./MarkdownEditor.vue?vue&type=style&index=1&id=60143933&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60143933",
  null
  
)

export default component.exports